export default "__VITE_ASSET__DKV8_JSq__"